import { render, staticRenderFns } from "./DuiNeedsSr22.vue?vue&type=template&id=676ab5b6&"
import script from "./DuiNeedsSr22.vue?vue&type=script&lang=js&"
export * from "./DuiNeedsSr22.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports